import {
  get, post, update, hapus, upload, download
} from './helpers'

// API GENERAL
export function getAssessment($data) {
  return get(`/peserta/assessment`, $data)
}

export function patchAssessment($data) {
  return post('peserta/assessment', $data)
}

export function updateStatusAssessment() {
  return post('peserta/update-assessment')
}